import { Badge } from '@mantine/core';
import FormattedRecordTimestamp from '../../../utils/FormattedRecordTimestamp';
import { Message, MessageStatus } from '../../messages/types';

const getStatusColor = (status?: MessageStatus) => {
    switch (status) {
        case 'UNREAD': return 'blue';
        case 'READ': return 'gray';
        case 'SENT': return 'green';
        case 'DELETED': return 'red';
        case 'ARCHIVED': return 'yellow';
        default: return 'gray';
    }
};

export const useMessagesTableColumns = () => {
    return [
        { accessor: 'from', title: 'From' },
        { accessor: 'to', title: 'To', render: (row: Message) => 
            Array.isArray(row.to) ? row.to.join(', ') : row.to 
        },
        { accessor: 'subject', title: 'Subject' },
        { accessor: 'status', title: 'Status', render: (row: Message) => (
            <Badge color={getStatusColor(row.status)}>{row.status}</Badge>
        )},
        { accessor: 'createdByUsername', title: 'Owner' },
        { accessor: 'created', title: 'Created', render: (row: Message) => (
            <FormattedRecordTimestamp record={row} propertyName="created" />
        )}
    ];
};
